import React, { useState, useEffect } from "react";
import StudentMenu from "./StudentMenu";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import BusrouteDropDown from "../Shared/BusrouteDropDown";
import ConcessionDropDown from "../Shared/ConcessionDropDown";
import StudentGroupDropDown from "../Shared/StudentGroupDropDown";
import EmployeeDropDown from "../Shared/EmployeeDropDown";
import { toast, ToastContainer } from "react-toastify";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import { NavLink, useNavigation } from "react-router-dom";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { scrollToTop } from '../Shared/ScrollOnTop';
import RightsCheck from '../General/RightsCheck';

/** Resolve wing/session/class/section IDs from API (PascalCase or camelCase). */
function pickStudentPlacement(student) {
  if (!student) {
    return { wingId: 0, sessionId: 0, classId: 0, sectionId: 0 };
  }
  const sc = student.SelectedClass || student.selectedClass || {};
  const ss = student.SelectedSection || student.selectedSection || {};
  const wingId =
    sc.Wing_Id ??
    sc.wing_Id ??
    sc.SelectedWing?.Wing_ID ??
    sc.selectedWing?.wing_ID ??
    0;
  const sessionId =
    sc.Session_ID ??
    sc.session_ID ??
    sc.Selected_Session?.Session_ID ??
    sc.selected_Session?.session_ID ??
    0;
  const classId =
    sc.Class_Id ?? sc.class_Id ?? student.Class_ID ?? student.class_ID ?? 0;
  const sectionId =
    ss.Section_ID ??
    ss.section_ID ??
    student.Section_Id ??
    student.section_Id ??
    0;
  return {
    wingId: Number(wingId) || 0,
    sessionId: Number(sessionId) || 0,
    classId: Number(classId) || 0,
    sectionId: Number(sectionId) || 0,
  };
}

function EditStudent(props) {
  const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID, setUserID] = useState(localStorage.getItem("ID"));
  const [MemberType, setMemberType] = useState(localStorage.getItem("MemberType"));
  const [WingID, setWingId] = useState(0);
  const [SessionID, setSessioinId] = useState(0);
  const [ClassID, setClassId] = useState(0);
  const [TransportId, setTransportId] = useState(0);
  const [SectionID, setSectionID] = useState(0);
  const [ConcessionID, setConcessionId] = useState(0);
  const [ConcessionStaffID, setConcessionStaffID] = useState(0);
  const [GroupId, setGroupId] = useState(0);
  const [loading, setLoading] = useState(false);
  const [studentLoading, setStudentLoading] = useState(true);
  const [sessionsLoading, setSessionsLoading] = useState(true);
  const [wingsLoading, setWingsLoading] = useState(true);
  const [classesLoading, setClassesLoading] = useState(false);
  const [sectionsLoading, setSectionsLoading] = useState(false);
  const [sessionOptions, setSessionOptions] = useState([]);
  const [wingOptions, setWingOptions] = useState([]);
  const [classOptions, setClassOptions] = useState([]);
  const [sectionOptions, setSectionOptions] = useState([]);

  const [ListofStatusHistory, setListofStatusHistory] = useState("");

  const [BayForm, setBayForm] = useState("");
  const [FormNo, setFormNo] = useState("");
  const [StudentName, setStudentName] = useState("");
  const [DateOfBirth, setDateOfBirth] = useState("");
  const [DateOfJoining, setdateofJoining] = useState("");
  const [FatherName, setFatherName] = useState("");
  const [FatherCNIC, setFatherCNIC] = useState("");
  const [VaccinationDate, setVaccinationDate] = useState("");
  const [VaccinationStatus, setVaccinationStatus] = useState("");

  const [TemporaryAddress, setTemporaryAddress] = useState("");
  const [PermanentAddress, setPermanentAddress] = useState("");
  const [ContactNumber, setContactNumber] = useState("");
  const [MobileNumber, setMobileNumber] = useState("");
  const [EmailAddress, setEmailAddress] = useState("");
  const [PreviousSchoolInfo, setPreviousSchoolInfo] = useState("");
  const [NOCBoard, setNOCBoard] = useState("");
  const [Remarks, setRemarks] = useState("");
  const [RegNo, setRegNo] = useState("");
  const [Gender, setGender] = useState(true);
  let params = useParams();
  const [Student_ID, setStudent_ID] = useState(params.id);
  const [Student, setStudent] = useState({});
  // photo
  const [isUpdated, setIsUpdated] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [image, setImage] = useState("");
  const [cropData, setCropData] = useState("");
  const [cropper, setCropper] = useState();
  const [imageSelected, setImageSelected] = useState(false);
  const [imageCropped, setImageCropped] = useState(false);
  const [imgData, setImageData] = useState("");
  const [listOfLedger, setLedger] = useState([]);
  const [ModifiedTime, setModifiedTime] = useState('');

  // pagination
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [Blood_Group, setBlood_Group] = useState("");

  const handleShowModal = () => setShowModal(true);

  const handleCloseModal = () => {
    setShowModal(false);
    setImageSelected(false);
    setLoading(false);
  };

  const navigate = useNavigate();

  const handleGenderChange = (event) => {
    setGender(event.target.checked);
  };


  const [validated, setValidated] = useState(false);

  const apiPost = (url, data) =>
    axios({
      method: "post",
      url: config.base_url + url,
      headers: { "Content-Type": "application/json" },
      data: { AccessKey, UserID, MemberType, ...data },
    });

  const fetchSessions = async () => {
    setSessionsLoading(true);
    try {
      const res = await apiPost("AcademicSession/GetAcademicSessions", {
        PageNo: 1,
        PageSize: 1000,
        SchoolID: 1,
      });
      const list = res.data?.ListofRecords || [];
      setSessionOptions(list);
      return list;
    } catch (e) {
      setSessionOptions([]);
      return [];
    } finally {
      setSessionsLoading(false);
    }
  };

  const fetchWings = async () => {
    setWingsLoading(true);
    try {
      const res = await apiPost("Wings/GetSchoolWings", {
        SchoolID: 1,
        PageNo: 1,
        PageSize: 100,
      });
      const list = res.data?.ListofRecords || [];
      setWingOptions(list);
      return list;
    } catch (e) {
      setWingOptions([]);
      return [];
    } finally {
      setWingsLoading(false);
    }
  };

  const fetchClasses = async (wingId, sessionId) => {
    if (!wingId || !sessionId) {
      setClassOptions([]);
      return [];
    }
    setClassesLoading(true);
    try {
      const res = await apiPost("WingClass/GetClassesByWingnSessionID", {
        Wing_Id: wingId,
        SessionID: sessionId,
        pageNo: 1,
        pageSize: 1000,
      });
      const list = res.data?.ListofRecords || [];
      setClassOptions(list);
      return list;
    } catch (e) {
      setClassOptions([]);
      return [];
    } finally {
      setClassesLoading(false);
    }
  };

  const fetchSections = async (classId) => {
    if (!classId) {
      setSectionOptions([]);
      return [];
    }
    setSectionsLoading(true);
    try {
      const res = await apiPost("Sections/GetAllSections", {
        Class_Id: classId,
        pageNo: 1,
        pageSize: 1000,
      });
      const list = res.data?.ListofRecords || [];
      setSectionOptions(list);
      return list;
    } catch (e) {
      setSectionOptions([]);
      return [];
    } finally {
      setSectionsLoading(false);
    }
  };

  const applyClassAndSectionSelection = async (wingId, sessionId, classId, sectionId) => {
    const classes = await fetchClasses(wingId, sessionId);
    const matchedClassId = classes.some(
      (c) => Number(c.Class_Id) === Number(classId)
    )
      ? Number(classId)
      : 0;
    setClassId(matchedClassId);

    if (matchedClassId) {
      const sections = await fetchSections(matchedClassId);
      const matchedSectionId = sections.some(
        (s) => Number(s.Section_ID) === Number(sectionId)
      )
        ? Number(sectionId)
        : 0;
      setSectionID(matchedSectionId);
    } else {
      setSectionOptions([]);
      setSectionID(0);
    }
  };

  const handleSessionChange = async (sessionId) => {
    const sid = Number(sessionId) || 0;
    setSessioinId(sid);
    setClassId(0);
    setSectionID(0);
    setClassOptions([]);
    setSectionOptions([]);
    if (sid > 0 && WingID > 0) {
      await fetchClasses(WingID, sid);
    }
  };

  const handleWingChange = async (wingId) => {
    const wid = Number(wingId) || 0;
    setWingId(wid);
    setClassId(0);
    setSectionID(0);
    setClassOptions([]);
    setSectionOptions([]);
    if (SessionID > 0 && wid > 0) {
      await fetchClasses(wid, SessionID);
    }
  };

  const handleClassChange = async (classId) => {
    const cid = Number(classId) || 0;
    setClassId(cid);
    setSectionID(0);
    setSectionOptions([]);
    if (cid > 0) {
      await fetchSections(cid);
    }
  };

  useEffect(() => {
    document.title = "Edit Student Information";
    let cancelled = false;

    const loadStudent = async () => {
      setStudentLoading(true);
      setClassesLoading(false);
      setSectionsLoading(false);
      setClassOptions([]);
      setSectionOptions([]);
      setWingId(0);
      setSessioinId(0);
      setClassId(0);
      setSectionID(0);

      try {
        const [sessions, wings, response] = await Promise.all([
          fetchSessions(),
          fetchWings(),
          apiPost("Student/GetStudentByID", { ID: Student_ID }),
        ]);

        if (cancelled) return;

        if (response.data.status_code !== 1) {
          toast.error(response.data.status_message || "Student not found.");
          return;
        }

        const s = response.data.Student;
        setStudent(s);
        setRegNo(s.Registration_No);
        setStudentName(s.Student_Name);
        setFatherName(s.Father_Name);
        setFatherCNIC(s.Father_CNIC);
        setTemporaryAddress(s.Temporary_Address);
        setPermanentAddress(s.Permanent_Address);
        setFormNo(s.Form_No);
        setGender(s.Gender);
        setDateOfBirth(moment(s.Date_Of_Birth).format("YYYY-MM-DD"));
        setdateofJoining(moment(s.Date_Of_Joining).format("YYYY-MM-DD"));
        setBlood_Group(s.Blood_Group);
        setContactNumber(s.Contact_Phone);
        setMobileNumber(s.Contact_Mobile);
        setEmailAddress(s.Contact_Email);
        setBayForm(s.Bay_Form_No);
        setVaccinationStatus(s.Vaccination_Status);
        setVaccinationDate(s.Vaccination_Date);
        setPreviousSchoolInfo(s.Previous_School_Info);
        setNOCBoard(s.NOC_Board);
        setRemarks(s.Remarks);
        setConcessionId(s.Concession_Rule_ID);
        setConcessionStaffID(s.ConcessionStaffID);
        setTransportId(s.Current_Route_Id);
        setGroupId(s.Student_Group_Id);

        const placement = pickStudentPlacement(s);
        const matchedSessionId = sessions.some(
          (x) => Number(x.Session_ID) === Number(placement.sessionId)
        )
          ? Number(placement.sessionId)
          : 0;
        const matchedWingId = wings.some(
          (x) => Number(x.Wing_ID) === Number(placement.wingId)
        )
          ? Number(placement.wingId)
          : 0;

        setSessioinId(matchedSessionId);
        setWingId(matchedWingId);
        setClassId(0);
        setSectionID(0);

        setListofStatusHistory(response.data.ListofStatusHistory);
        setModifiedTime(response.data.NoofTimesModified);
        setLedger(response.data.ListofStatusHistory);

        if (matchedWingId > 0 && matchedSessionId > 0) {
          await applyClassAndSectionSelection(
            matchedWingId,
            matchedSessionId,
            placement.classId,
            placement.sectionId
          );
        }
      } catch (error) {
        if (!cancelled) {
          toast.error("Network Error..", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      } finally {
        if (!cancelled) {
          setStudentLoading(false);
        }
      }
    };

    loadStudent();
    return () => {
      cancelled = true;
    };
  }, [Student_ID]);


  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      setLoading(true);
      const data = {
        AccessKey: AccessKey,
        UserID: UserID,
        Registration_No: RegNo,
        Student_Name: StudentName,
        Father_Name: FatherName,
        Father_CNIC: FatherCNIC,
        Temporary_Address: TemporaryAddress,
        Permanent_Address: PermanentAddress,
        Date_Of_Birth: DateOfBirth,
        Contact_Phone: ContactNumber,
        Contact_Mobile: MobileNumber,
        Contact_Email: EmailAddress,
        Bay_Form_No: BayForm,
        Class_ID: ClassID,
        Previous_School_Info: PreviousSchoolInfo,
        NOC_Board: NOCBoard,
        Remarks: Remarks,
        Form_No: FormNo,
        Concession_Rule_ID: ConcessionID,
        ConcessionStaffID: ConcessionStaffID,
        Current_Route_Id: TransportId,
        Student_Group_Id: GroupId,
        Section_Id: SectionID,
        Vaccination_Status: VaccinationStatus,
        Vaccination_Date: VaccinationDate,
        Gender: Gender,
        Image: cropData,
        Student_ID: Student_ID,
        Blood_Group: Blood_Group
      };

      var api_config = {
        method: "post",
        url: config.base_url + "Student/UpdateStudent",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      //console.log('data', data);
      axios(api_config)
        .then(function (response) {
          if (response.data.status_code == 1) {
            toast.success(response.data.status_message, {
              position: toast.POSITION.TOP_RIGHT,
            });
            navigate(`${'/students/SearchStudents'}`);
          } else {
            toast.error(response.data.status_message, {
              position: toast.POSITION.TOP_RIGHT,
            });
          }

          setLoading(false);
        })
        .catch(function (error) {
          setLoading(false);
          toast.error("Network Error..", {
            position: toast.POSITION.TOP_RIGHT,
          });
        });
    }

    setValidated(true);
  };

  const onChange = (e) => {
    e.preventDefault();
    setImageSelected(true);
    let files;
    if (e.dataTransfer) {
      files = e.dataTransfer.files;
    } else if (e.target) {
      files = e.target.files;
    }
    const reader = new FileReader();
    reader.onload = () => {
      setImage(reader.result);
    };
    reader.readAsDataURL(files[0]);
  };

  const getCropData = () => {
    if (typeof cropper !== "undefined") {
      var cropData1 = cropper.getCroppedCanvas().toDataURL();
      setImageCropped(true);

      var cleanerBase64 = cropData1.substring(22);
      setCropData(cleanerBase64);
      setImageData(cropData1);
    }

    handleCloseModal();
  };

  const renderButtons = () => {
    if (imageSelected === true) {
      return (
        <>
          <div className="modal-footer justify-content-center">
            <button
              className="button button-outline-primary me-2"
              onClick={handleCloseModal}
            >
              Close
            </button>
            <button className="button button-primary" onClick={getCropData}>
              Save Photo
            </button>
          </div>
        </>
      );
    } else if (imageSelected === false && isUpdated === true) {
      return (
        <>
          <div className="modal-footer justify-content-center">
            <button
              className="button button-outline-primary me-2"
              onClick={handleCloseModal}
            >
              Close
            </button>
          </div>
        </>
      );
    }
  };
  const renderLedger = () => {
    if (listOfLedger.length > 0) {
      return listOfLedger.map((item, index) => {
        return (
          <tr key={index}>
            <td>{item.Serial_No}</td>
            <td>{item.Student_Name}</td>
            <td>{item.Status_Type_Name}</td>
            <td>{moment(item.Dated).format("DD/MM/YYYY")}</td>
            <td>{item.Modified_By}</td>
            <td>{item.Remarks}</td>
          </tr>
        );
      });
    } else {
      return (
        <tr>
          <td colspan="8">
            <h4
              className="mt-3"
              style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
            >
              No Data Found
            </h4>
          </td>
        </tr>
      );
    }
  };
  return (
    <>
      <StudentMenu />
      <ToastContainer />
      <RightsCheck />
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Update Profile Photo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isUpdated ? (
            <>
              <div className="text-center">
                <p>Photo Updated Successfully</p>
              </div>
            </>
          ) : (
            <>
              <div className="upload-photo-wrap">
                {imageSelected ? (
                  <Cropper
                    zoomTo={0.5}
                    aspectRatio={8 / 8}
                    preview=".img-preview"
                    src={image}
                    dragMode="move"
                    viewMode={2}
                    minCropBoxHeight={10}
                    minCropBoxWidth={10}
                    background={false}
                    responsive={true}
                    autoCropArea={1}
                    checkOrientation={false} // https://github.com/fengyuanchen/cropperjs/issues/671
                    onInitialized={(instance) => {
                      setCropper(instance);
                    }}
                    guides={true}
                  />
                ) : (
                  <div className="choose-photo">
                    <label htmlFor="ChoosePhoto">
                      <i className="ri-upload-cloud-line"></i>
                      <span>Browse Photo</span>
                      <input
                        id="ChoosePhoto"
                        accept="image/jpeg,image/png"
                        type="file"
                        onChange={onChange}
                      />
                    </label>
                  </div>
                )}
              </div>
            </>
          )}
        </Modal.Body>

        {renderButtons()}
      </Modal>
      <div className="container body-content">
        <div className="page-head">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <NavLink to="/Dashboard">Dashboard</NavLink>
                    </li>
                    <li className="breadcrumb-item">
                      <NavLink to="/students/StudentDashboard">
                        Students
                      </NavLink>
                    </li>

                    <li className="breadcrumb-item active" aria-current="page">
                      Edit / Update Student
                    </li>
                  </ol>
                </nav>
                <div className="page-title">Edit / Update Student</div>
              </div>
              <div className="col-md-6">
                <div className="page-right-actions">
                  <NavLink
                    to="/students/SearchStudents"
                    className="button button-white button-icon"
                  >
                    Search Students
                    <i className="ri-search-line"></i>
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="page-content">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body card-form-wrap">
                    <Form
                      noValidate
                      validated={validated}
                      onSubmit={handleSubmit}
                    >
                      <div className="form-wrap">
                        <div className="form-legend">Basic Information</div>
                        <div className="row align-items-center">
                          <div className="col-md-9">
                            <div className="row align-items-center g-3 m-0">
                              <label
                                htmlFor=""
                                className="col-md-2 col-form-label col-form-label-sm"
                              >
                                Bay Form
                              </label>
                              <div className="col-md-4">
                                <input
                                  type="text"
                                  numbers-Only
                                  className="form-control"
                                  value={BayForm}
                                  onChange={(e) => setBayForm(e.target.value)}
                                  id=""
                                />
                              </div>
                              <label
                                htmlFor=""
                                className="col-md-2 col-form-label col-form-label-sm"
                              >
                                Form No.
                              </label>
                              <div className="col-md-4">
                                <input
                                  type="text"
                                  numbers-Only
                                  className="form-control"
                                  value={FormNo}
                                  onChange={(e) => setFormNo(e.target.value)}
                                  id=""
                                />
                              </div>
                              <label
                                htmlFor=""
                                className="col-md-2 col-form-label col-form-label-sm"
                              >
                                Student Name
                              </label>
                              <div className="col-md-4">
                                <input
                                  type="text"
                                  required
                                  className="form-control"
                                  value={StudentName}
                                  onChange={(e) =>
                                    setStudentName(e.target.value)
                                  }
                                  id=""
                                />
                              </div>
                              <label
                                htmlFor=""
                                className="col-md-2 col-form-label col-form-label-sm"
                              >
                                Date of Birth
                              </label>
                              <div className="col-md-4">
                                <input
                                  type="date"
                                  required
                                  className="form-control"
                                  value={DateOfBirth}
                                  onChange={(e) =>
                                    setDateOfBirth(e.target.value)
                                  }
                                />
                              </div>
                              <label
                                htmlFor=""
                                className="col-md-2 col-form-label col-form-label-sm"
                              >

                                Father Name
                              </label>
                              <div className="col-md-4">
                                <input
                                  type="text"
                                  required
                                  className="form-control"
                                  value={FatherName}
                                  onChange={(e) =>
                                    setFatherName(e.target.value)
                                  }
                                  id=""
                                />
                              </div>
                              <label
                                htmlFor=""
                                className="col-md-2 col-form-label col-form-label-sm"
                              >
                                Father CNIC
                              </label>
                              <div className="col-md-4">
                                <input
                                  type="text"
                                  numbers-Only
                                  className="form-control"
                                  value={FatherCNIC}
                                  onChange={(e) =>
                                    setFatherCNIC(e.target.value)
                                  }
                                  id=""
                                />
                              </div>
                              <label
                                htmlFor=""
                                className="col-md-2 col-sm-4 col-form-label col-form-label-sm"
                              >
                                Blood Group
                              </label>
                              <div className="col-md-4 col-sm-8">
                                <input
                                  type="text"
                                  className="form-control"
                                  value={Blood_Group}
                                  onChange={(e) =>
                                    setBlood_Group(e.target.value)
                                  }
                                  id=""
                                />
                              </div>
                              <label
                                htmlFor=""
                                className="col-md-2 col-form-label col-form-label-sm"
                              >
                                Gender
                              </label>
                              <div className="col-md-4">
                                <div className="mt-1">
                                  <div className="form-check form-check-inline">
                                    <label className="form-check-label">
                                      <input
                                        type="radio"
                                        name="gender"
                                        value="male"
                                        checked={Gender === true}
                                        onChange={() => setGender(true)}
                                      />
                                      Male
                                    </label>
                                  </div>
                                  <div className="form-check form-check-inline me-0">
                                    <label className="form-check-label">
                                      <input
                                        type="radio"
                                        name="gender"
                                        value="female"
                                        checked={Gender === false}
                                        onChange={() => setGender(false)}
                                      />
                                      Female
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-3 text-center">
                            {imgData == "" ? (
                              <img
                                className="mb-3"
                                src={RegNo != "" ? config.StudentImagePath + RegNo + ".jpg" : config.StudentImagePath + Student_ID + ".jpg"}
                                style={{ width: "150px" }}
                              />
                            ) : (
                              <img
                                className="mb-3"
                                src={imgData}
                                style={{ width: "150px" }}
                              />
                            )}
                            <button
                              type="button"
                              onClick={handleShowModal}
                              className="button  button-small"
                            >
                              Choose Photo
                            </button>
                          </div>
                        </div>
                        <div className="row align-items-center mt-0">
                          <label
                            htmlFor=""
                            className="col-md-2 col-form-label col-form-label-sm"
                          >
                            Vaccination Status
                          </label>
                          <div className="col-md-4">
                            <select
                              className="form-select"
                              value={Student.Vaccination_Status}
                              onChange={(e) =>
                                setVaccinationStatus(e.target.value)
                              }
                            >
                              <option value="" disabled selected>
                                Please Select
                              </option>
                              <option value="Not Vaccinated">
                                Not Vaccinated
                              </option>
                              <option value="Partially Vaccinated">
                                Partially Vaccinated
                              </option>
                              <option value="Fully Vaccinated">
                                Fully Vaccinated
                              </option>
                            </select>
                          </div>
                          <label
                            htmlFor=""
                            className="col-md-2 col-form-label col-form-label-sm"
                          >
                            Vaccination Date
                          </label>
                          <div className="col-md-4">
                            <input
                              type="date"
                              className="form-control"
                              // value={moment(VaccinationDate).format("yyyy MM dd ")}
                              value={moment(VaccinationDate).format("YYYY-MM-DD")}
                              onChange={(e) =>
                                setVaccinationDate(e.target.value)
                              }
                              id=""
                            />
                          </div>
                        </div>
                      </div>
                      <div className="form-wrap">
                        <div className="form-legend">Contact Information</div>
                        <div className="row">
                          <label
                            htmlFor=""
                            className="col-md-3 col-form-label col-form-label-sm"
                          >
                            Temporary Address
                          </label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              className="form-control"
                              value={TemporaryAddress}
                              onChange={(e) =>
                                setTemporaryAddress(e.target.value)
                              }
                              id=""
                            />
                          </div>
                        </div>
                        <div className="row">
                          <label
                            htmlFor=""
                            className="col-md-3 col-form-label col-form-label-sm"
                          >
                            Permanent Address
                          </label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              className="form-control"
                              value={PermanentAddress}
                              onChange={(e) =>
                                setPermanentAddress(e.target.value)
                              }
                              id=""
                            />
                          </div>
                        </div>
                        <div className="row">
                          <label
                            htmlFor=""
                            className="col-md-3 col-form-label col-form-label-sm"
                          >
                            Contact Number
                          </label>
                          <div className="col-md-3">
                            <input
                              type="text"
                              numbers-Only
                              className="form-control"
                              value={ContactNumber}
                              onChange={(e) => setContactNumber(e.target.value)}
                              id=""
                            />
                          </div>
                          <label
                            htmlFor=""
                            className="col-md-3 col-form-label col-form-label-sm"
                          >
                            Mobile Number
                          </label>
                          <div className="col-md-3">
                            <input
                              type="text"
                              numbers-Only
                              className="form-control"
                              value={MobileNumber}
                              onChange={(e) => setMobileNumber(e.target.value)}
                              id=""
                            />
                          </div>
                        </div>
                        <div className="row">
                          <label
                            htmlFor=""
                            className="col-md-3 col-form-label col-form-label-sm"
                          >
                            Email Address
                          </label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              className="form-control"
                              value={EmailAddress}
                              onChange={(e) => setEmailAddress(e.target.value)}
                              id=""
                            />
                          </div>
                        </div>
                      </div>
                      <div className="form-wrap">
                        <div className="form-legend">Session / Wing / Class / Section</div>
                        <div className="row gy-3">
                          <div className="col-md-3">
                            <div className="form-group">
                              <label>
                                Choose Session
                                {(studentLoading || sessionsLoading) && (
                                  <Spinner
                                    animation="border"
                                    size="sm"
                                    className="ms-2"
                                  />
                                )}
                              </label>
                              <select
                                className="form-select"
                                required
                                value={SessionID ? String(SessionID) : ""}
                                onChange={(e) =>
                                  handleSessionChange(e.target.value)
                                }
                                disabled={studentLoading || sessionsLoading}
                                size={4}
                                style={{ height: "200px" }}
                              >
                                <option value="">
                                  {sessionsLoading
                                    ? "Loading sessions…"
                                    : "Please Select"}
                                </option>
                                {sessionOptions.map((item) => (
                                  <option
                                    key={item.Session_ID}
                                    value={String(item.Session_ID)}
                                  >
                                    {item.Session_Name}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-group">
                              <label>
                                Choose Wing
                                {(studentLoading || wingsLoading) && (
                                  <Spinner
                                    animation="border"
                                    size="sm"
                                    className="ms-2"
                                  />
                                )}
                              </label>
                              <select
                                value={WingID ? String(WingID) : ""}
                                onChange={(e) => handleWingChange(e.target.value)}
                                className="form-select"
                                required
                                disabled={studentLoading || wingsLoading}
                                size={4}
                                style={{ height: "200px" }}
                              >
                                <option value="">
                                  {wingsLoading
                                    ? "Loading wings…"
                                    : "Please Select"}
                                </option>
                                {wingOptions.map((item) => (
                                  <option
                                    key={item.Wing_ID}
                                    value={String(item.Wing_ID)}
                                  >
                                    {item.Wing_Name}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-group">
                              <label>
                                Select Class
                                {(studentLoading || classesLoading) && (
                                  <Spinner
                                    animation="border"
                                    size="sm"
                                    className="ms-2"
                                  />
                                )}
                              </label>
                              <select
                                className="form-select"
                                required
                                value={ClassID ? String(ClassID) : ""}
                                onChange={(e) =>
                                  handleClassChange(e.target.value)
                                }
                                disabled={
                                  studentLoading ||
                                  classesLoading ||
                                  !SessionID ||
                                  !WingID
                                }
                                size={4}
                                style={{ height: "200px" }}
                              >
                                <option value="">
                                  {classesLoading
                                    ? "Loading classes…"
                                    : "Please Select"}
                                </option>
                                {classOptions.map((item) => (
                                  <option
                                    key={item.Class_Id}
                                    value={String(item.Class_Id)}
                                  >
                                    {item.Class_Name}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-group">
                              <label>
                                Select Section
                                {(studentLoading || sectionsLoading) && (
                                  <Spinner
                                    animation="border"
                                    size="sm"
                                    className="ms-2"
                                  />
                                )}
                              </label>
                              <select
                                className="form-select"
                                required
                                value={SectionID ? String(SectionID) : ""}
                                onChange={(e) =>
                                  setSectionID(Number(e.target.value) || 0)
                                }
                                disabled={
                                  studentLoading ||
                                  sectionsLoading ||
                                  !ClassID
                                }
                                size={4}
                                style={{ height: "200px" }}
                              >
                                <option value="">
                                  {sectionsLoading
                                    ? "Loading sections…"
                                    : "Please Select"}
                                </option>
                                {sectionOptions.map((item) => (
                                  <option
                                    key={item.Section_ID}
                                    value={String(item.Section_ID)}
                                  >
                                    {item.Section_Name}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="form-wrap">
                        <div className="form-legend">Transport / Concessions / Group</div>
                        <div className="row gy-3">
                          <div className="col-md-4">
                            <div className="form-group">
                              <label>Transport Facility</label>
                              <select className="form-select" value={TransportId} onChange={(e) => setTransportId(e.target.value)}>
                                <option value="-1">Please Select</option>
                                {
                                  <BusrouteDropDown />
                                }

                              </select>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-group">
                              <label>Select Concessions</label>
                              <select className="form-select" required value={ConcessionID} onChange={(e) => setConcessionId(e.target.value)}>
                                <option value="">Please Select</option>
                                {
                                  <ConcessionDropDown />
                                }

                              </select>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-group">
                              <label>Select Staff</label>
                              <select className="form-select" value={ConcessionStaffID} onChange={(e) => setConcessionStaffID(e.target.value)}>
                                <option value="">Please Select</option>
                                {
                                  <EmployeeDropDown selected={setConcessionStaffID} />
                                }

                              </select>
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="form-group">
                              <label>Select Group</label>
                              <select className="form-select" required value={GroupId} onChange={(e) => setGroupId(e.target.value)}>
                                <option value="">Please Select</option>
                                {
                                  <StudentGroupDropDown />

                                }

                              </select>
                            </div>
                          </div>
                        </div>

                      </div>
                      <div className="form-wrap">
                        <div className="form-legend">Other Details</div>
                        <div className="row align-items-center gy-3">
                          <label
                            htmlFor=""
                            className="col-md-3 col-form-label col-form-label-sm"
                          >
                            Previous School Information
                          </label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              className="form-control"
                              value={PreviousSchoolInfo}
                              onChange={(e) =>
                                setPreviousSchoolInfo(e.target.value)
                              }
                            />
                          </div>

                          <label
                            htmlFor=""
                            className="col-md-3 col-form-label col-form-label-sm"
                          >
                            NOC Board Information
                          </label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              className="form-control"
                              value={NOCBoard}
                              onChange={(e) => setNOCBoard(e.target.value)}
                            />
                          </div>

                          <label
                            htmlFor=""
                            className="col-md-3 col-form-label col-form-label-sm"
                          >
                            Remarks
                          </label>
                          <div className="col-md-9">
                            {/* <input
                              type="text"
                              className="form-control"
                              value={Remarks}
                              onChange={(e) => setRemarks(e.target.value)}
                            /> */}

                            <textarea
                              className="form-control"
                              value={Remarks}
                              onChange={(e) => setRemarks(e.target.value)}
                              rows="4" // You can adjust the number of rows as needed
                            />

                          </div>
                          <label
                            htmlFor=""
                            className="col-md-3 col-form-label col-form-label-sm"
                          >
                            Registration Number
                          </label>
                          <div className="col-md-4">
                            <input
                              type="text"
                              className="form-control"
                              value={RegNo}
                              onChange={(e) => setRegNo(e.target.value)}
                            />
                          </div>

                        </div>

                        <div className="row">
                          <div className="col-md-4 offset-md-5 text-md-end">
                            <div className="form-group ">
                              {loading ? (
                                <Spinner
                                  animation="border"
                                  role="status"
                                ></Spinner>
                              ) : (
                                <NavLink
                                  to={`/students/StudentHistory/${Student_ID}`}

                                  className="mt-2 button button-primary w-100 "
                                >
                                  Record History Modified {ModifiedTime} Time(s)
                                </NavLink>
                              )}
                            </div>
                          </div>
                          <div className="col-md-3 text-md-end">
                            <div className="form-group ">
                              {loading ? (
                                <Spinner
                                  animation="border"
                                  role="status"
                                ></Spinner>
                              ) : (
                                <button
                                  type="submit"
                                  value="Save"
                                  className="mt-2 button button-primary w-100 "
                                >
                                  UPDATE STUDENT
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="row mt-2">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <table className="table table-theme">
                      <thead>
                        <tr>
                          <th colSpan={6}>Students Status History Details :</th>
                        </tr>
                        <tr>
                          <th>Serial No</th>
                          <th>Student Name</th>
                          <th>Status Details</th>
                          <th>Dated</th>
                          <th>Modified By</th>
                          <th>Remarks</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <td className="text-center" colspan="12">
                              <Spinner
                                animation="border"
                                role="status"
                              ></Spinner>
                            </td>
                          </tr>
                        ) : (
                          <>{renderLedger()}</>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div >
      </div >
    </>
  );
}

export default EditStudent;
